import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  textAlign: "center",
};

const QuizAlertModal = ({
  open,
  onClose,
  description,
  subText,
  onYes,
  onNo,
  loading = false,
}) => {

  return (
    <Modal open={open} onClose={() => !loading && onClose()}>
      <Box sx={style}>
        <Typography gutterBottom>{description}</Typography>

        {subText && <Typography sx={{ mb: 2 }}>{subText}</Typography>}

        <Box className="d-flex justify-content-center gap-2 mt-2">
          <Button
            variant="contained"
            color="success"
            onClick={onYes}
            disabled={loading}
          >
            Yes
            {loading && (
              <span className="spinner-border spinner-border-sm ms-2"></span>
            )}
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={onNo}
            disabled={loading}
          >
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuizAlertModal;
